var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCsharpLanguageIcon = function SvgCsharpLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    fill: "#16181c",
    rx: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 17,
    fill: "#fff",
    fontFamily: "Onest, sans-serif",
    fontSize: 9.5,
    fontWeight: 800,
    textAnchor: "middle"
  }, "\n\t\tC#\n\t")));
};
export default SvgCsharpLanguageIcon;